import { render, staticRenderFns } from "./MyHealthList.vue?vue&type=template&id=6939ae3b"
import script from "./MyHealthList.vue?vue&type=script&lang=js"
export * from "./MyHealthList.vue?vue&type=script&lang=js"
import style0 from "./MyHealthList.vue?vue&type=style&index=0&id=6939ae3b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports